import MicroModal from 'micromodal';

export const INIT_modals = () => {
    MicroModal.init({
        disableScroll: true,
    });

    window.addEventListener('click', event => {
        const target = event.target;

        if (target.dataset.micromodalTrigger == 'modal-callback') {
            MicroModal.show(target.dataset.micromodalTrigger);
        }
    });
};
